import DynamicBreadcrumb from '../../models/navigation/DynamicBreadcrumb';

export interface GlobalState {
    dynamicBreadcrumb?: DynamicBreadcrumb;
    selectedWorklistsTab?: string;
    error?: string;
    bannerItems: Array<any>;
    pageSidebarKey?: string;
    selectedTab?: string;
}

export const initialState: GlobalState = {
    bannerItems: []
}